import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoints } from './endpoints';
import { ExperienceTransferItemWire } from './types';

export const api = {
  loadExperienceTransfer: async (id: number): Promise<ExperienceTransferItemWire> => {
    const response = await new RemoteAdminData(endpoints.experienceTransferItem)
      .resource<ApiResponse<ExperienceTransferItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },
  addExperienceTransfer: async (experienceTransferItem: ExperienceTransferItemWire): Promise<number> => {
    const response: any = await new RemoteAdminData(endpoints.experienceTransferItem)
      .resource<ApiResponse<number>>()
      .create(experienceTransferItem, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },
  updateExperienceTransfer: async (id: number, experienceTransferItem: ExperienceTransferItemWire): Promise<number> => {
    await new RemoteAdminData(endpoints.experienceTransferItem)
      .resource<void>()
      .withId(id)
      .save(experienceTransferItem);

    return id;
  },
  deleteExperienceTransfer: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.experienceTransferItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  }
};
